import { Component, OnInit, OnDestroy, Inject, ViewChild, Input } from '@angular/core';
import { HistoryService } from '../../services/history.service';
import { tap } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { ProfileFieldHistoryDataSource } from '../../datasources/profile-field-history.datasource';
import { Observable } from 'rxjs';

@Component({
  selector: 'field-data-historical-modal-modal',
  templateUrl: './field-data-historical-modal.component.html',
  styleUrls: ['./field-data-historical-modal.component.scss'],
  standalone: false
})
export class FieldDataHistoricalModalComponent implements OnInit, OnDestroy {
  displayedColumns: Array<string> = ['happenedOn', 'name', 'from', 'to'];
  readonly dataSource: ProfileFieldHistoryDataSource;
  public rowCount: Observable<number>;
  @Input()
  attributeName;
  @Input()
  personId;
  @Input()
  teamId;
  @Input()
  entityType;

  readonly DEFAULT_PAGE_SIZE = 30;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private historyService: HistoryService) {
    this.dataSource = new ProfileFieldHistoryDataSource(historyService);
  }

  ngOnInit(): void {
    this.loadProfileHistory();
  }

  ngOnDestroy(): void {}

  ngAfterViewInit(): void {
    this.paginator.page.pipe(tap(() => this.loadProfileHistory())).subscribe();
  }

  loadProfileHistory(): void {
    this.dataSource.loadHistory(
      this.paginator.pageIndex,
      this.DEFAULT_PAGE_SIZE,
      this.personId,
      this.teamId,
      this.attributeName,
      this.entityType
    );
  }
}
